export const NEW_USER = 'v2/collaborators'
export const GET_USERS = 'v2/collaborators'
export const GET_PERMISSIONS = 'v2/collaborators/permissions'
export const ADD_PERMISSIONS = 'v2/collaborators/permissions'
export const UPDATE_STATUS = 'v2/collaborators/status'
export const NEW_PASSWORD = 'v2/collaborators/password'